@if (visible()) {
  <div
    class="call-status-bar w-full p-3 cursor-pointer"
    (click)="showModal()"
    [style.background-color]="statusColor()"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <app-icon
          [name]="isCallAudio() ? 'call/calling-icon' : 'meeting/camera-on-icon'"
          [size]="24"
          svgClass="text-white"
        />
        <div class="flex flex-col gap-1">
          <span class="text-white font-semibold text-base">
            {{ userName() }}
          </span>
          <span
            class="text-white/80 text-xs font-normal"
            [class.typing]="isIncomingCall() || callStore.callState() !== CALL_STATE.CONNECTED"
          >
            {{ label() }}
            @if (callStore.callState() === CALL_STATE.CONNECTED && !isIncomingCall()) {
              • {{ callDuration() }}
            }
          </span>
        </div>
      </div>

      <div class="flex items-center gap-3">
        @if (isIncomingCall()) {
          <button
            class="w-[40px] h-[40px] p-2 bg-[--color-border-error] rounded-full active:scale-95 transition"
            (click)="rejectIncomingCall($event)"
          >
            <app-icon name="call/x-icon" [size]="24" svgClass="text-white" />
          </button>
          @if (isWaiting() || isInMeeting()) {
            <img
              src="assets/icon/call/switch-call-icon.svg"
              alt="switch-call-icon"
              class="cursor-pointer w-[40px] h-[40px] active:scale-95 transition"
              (click)="acceptIncomingCall($event)"
            />
          } @else {
            <button
              class="w-[40px] h-[40px] p-2 bg-call-accept rounded-full active:scale-95 transition"
              (click)="acceptIncomingCall($event)"
            >
              <app-icon
                [name]="isCallAudio() ? 'call/start-call-icon' : 'meeting/camera-on-icon'"
                [size]="24"
                svgClass="text-white"
              />
            </button>
          }
        } @else {
          <button
            nz-button
            nzType="default"
            [disabled]="callStore.callState() !== CALL_STATE.CONNECTED"
            (click)="toggleMic($event)"
            class="w-[40px] h-[40px] p-2 bg-[--color-secondary] rounded-full active:scale-95 transition"
            [class.!bg-white]="!localMicState() && isMicPermissionGranted() && hasMicDevice()"
            [class.!bg-[--color-border-error]]="!isMicPermissionGranted() || !hasMicDevice()"
          >
            <app-icon
              [name]="
                localMicState() && isMicPermissionGranted() && hasMicDevice()
                  ? 'meeting/mic-on-icon'
                  : 'meeting/mic-off-icon'
              "
              [size]="24"
              [svgClass]="
                !isMicPermissionGranted() || !hasMicDevice() || localMicState()
                  ? 'text-[--color-text-onsecondary]'
                  : 'text-[--color-text-error]'
              "
            />
          </button>
          <button class="w-[40px] h-[40px] p-2 bg-call-end rounded-full" (click)="endCall($event)">
            <app-icon name="meeting/end-call" [size]="24" svgClass="text-white" />
          </button>
        }
      </div>
    </div>
  </div>
}
